import {makeReactContext} from 'lib/makeReactContext';

import {UseDiagramLayoutStateOutput} from './diagram-layout/useDiagramLayout';

const DiagramLayoutContext = makeReactContext<UseDiagramLayoutStateOutput>(() => {
  throw new Error('Could not find DiagramLayout context while rendering entity relationship diagram.');
}, 'DiagramLayoutContext');

export function useDiagramLayoutContext(): UseDiagramLayoutStateOutput {
  return DiagramLayoutContext.useContext();
}

export default DiagramLayoutContext;
